module.exports = __webpack_public_path__ + "static/media/int-bg-5.99fd8e7f.jpg";